/* tslint:disable */
/* eslint-disable */
/**
 * Neptune Leaderboard REST API
 * Public REST API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: contact@neptune.ml
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RunListDTO
 */
export interface RunListDTO {
    /**
     * 
     * @type {Array<string>}
     * @memberof RunListDTO
     */
    runs?: Array<string>;
}

/**
 * Check if a given object implements the RunListDTO interface.
 */
export function instanceOfRunListDTO(value: object): value is RunListDTO {
    return true;
}

export function RunListDTOFromJSON(json: any): RunListDTO {
    return RunListDTOFromJSONTyped(json, false);
}

export function RunListDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): RunListDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'runs': json['runs'] == null ? undefined : json['runs'],
    };
}

export function RunListDTOToJSON(value?: RunListDTO | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'runs': value['runs'],
    };
}

